//@ts-nocheck
import React from "react";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import QuestionCard from "./layout/QuestionCard.web";
import OptionList from "./layout/OptionList.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";

class BusinessNeedStep extends React.Component {
  async componentDidMount() {
    const stepNo = this.props.taxPayerType === "individual" ? "8.1" : "8.2";
    this.props.getQuestionAndOptionsByStepNo(stepNo);
  }
  render() {
    const selection = this.props.businessNeedSelection || [];
    return (
      <>
        <QuestionCard
          title={this.props?.stepContent?.description}
          hint="Select any that apply"
        >
          <OptionList
            options={this.props?.stepContent?.options?.data}
            selected={selection}
            multiple
            onSelect={this.props.setBusinessNeedSelection}
          />
        </QuestionCard>
        <FirmQuestions
          screen={this.props.taxPayerType === "individual" ? "career" : "progress"}
          taxPayerType={this.props.taxPayerType}
          questions={this.props.firmQuestions}
          answers={this.props.firmAnswers}
          onChange={this.props.setFirmAnswer}
        />
        <StepFooter
          onBack={this.props.handleBack}
          onNext={this.props.handleNext}
          nextDisabled={selection.length === 0}
        />
      </>
    );
  }
}
const BusinessNeedStepWithRouter = withRouter(BusinessNeedStep);
const BusinessNeedStepAlertBox = withAlertBox(BusinessNeedStepWithRouter);
const BusinessNeedStepLoader = withLoader(BusinessNeedStepAlertBox);
const BusinessNeedStepToast = withToast(BusinessNeedStepLoader);
const BusinessNeedStepWithDialog = withDialog(BusinessNeedStepToast);

export default withConfirmBox(BusinessNeedStepWithDialog);
